<div class="fullcontainer">
  <br />
  <br />
  <div class='titleContainer'>
    <h2 class='header' style='color:#006598;'>Delivery Notes</h2>
    <div>
      <button class='btn btn-secondary' routerLink='/delivery-notes/new'><i class="fas fa-plus"></i> New</button>&nbsp;
      <button class='btn btn-secondary' routerLink='/picking-slips'><i class="fas fa-clipboard-check"></i> Picking Slips</button>
    </div>
  </div>

  @for (s of this.statusButtons; track s.value) {
    <button class='btn' (click)='this.setStatus(s.value)' [class.btn-primary]='this.status === s.value' [class.btn-secondary]='this.status !== s.value'>
      <i [class]='s.icon'></i> {{ s.label }}</button>&nbsp;
  }
  <br />
  <br />
  @if (this.error) { <div class='alert alert-danger'>{{ this.error }}</div> }
  <app-grid
    entity='delivery-note'
    [columns]='this.columns'
    [buttons]='this.buttons'
    [searchFilters]='this.searchFilters'
    [searchFields]='this.searchFields'
  ></app-grid>
</div>
